
import { View, } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const MeInformationOnline = ({ navigation, route }) => {
    const {
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        ids,
        total
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const { postmeonline, loading } = useFormsStore()

    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey: intializestore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            maritalStatus: values?.martialStatus,
            additionalAmount: values?.additionalwithholding ? Number(values?.additionalwithholding) : null,
            stateIncomeTaxWithheld: ids,
            exemptionForYourself: values?.exemptionForYourself ? Number(values?.exemptionForYourself) : null,
            exemptionForSpouse: values?.exemptionForSpouse ? Number(values?.exemptionForSpouse) : null,
            exemptionForHeadOfHousehold: values?.exemptionForHeadOfHousehold ? Number(values?.exemptionForHeadOfHousehold) : null,
            noOfDependents: values?.noOfDependents ? Number(values?.noOfDependents) : null,
            totalAllowances:
                Number(values?.exemptionForYourself) +
                Number(values?.exemptionForSpouse) +
                Number(values?.exemptionForHeadOfHousehold) +
                Number(values?.noOfDependents),
            tribalMemberExemption: values?.tribalMemberExemption,
            sign: signatureDataURL,
        }
        const response = await postmeonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'ME Withholding Taxation'}
                    />
                </View>
            </View>

            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('MeInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}
export default MeInformationOnline
